import { useCheckoutSession } from "./CheckoutSession";
import { PhoneAuthentication } from "./PhoneAuthentication";

type Props = {
  eventId: string;
  onComplete: () => void;
};

export function CheckoutPhoneAuthentication({ eventId, onComplete }: Props) {
  const checkout = useCheckoutSession();
  return (
    <PhoneAuthentication
      eventId={eventId}
      draft={checkout.draft}
      update={checkout.update}
      canContinue={checkout.canContinue}
      onBack={() => checkout.setStep("tickets")}
      onComplete={onComplete}
    />
  );
}
